import {IActionHandler} from "./action-handler.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";

export abstract class ActionHandlerBase<TPayload, TResult = void> implements IActionHandler<TPayload, TResult> {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    abstract handle(payload: TPayload): Promise<TResult>;
}